<template>
    <v-dialog v-model="show" max-width="1200" min-width="1200" width="1200" height="700" scrollable>
        <v-card style="height: 700px; max-height: 90vh; display: flex; flex-direction: column;">
            <v-card-title class="text-h5" style="flex-shrink: 0;">
                <div class="d-flex justify-space-between align-center" style="width: 100%;">
                    <div>
                        Mesas
                    </div>
                    <v-btn @click.stop="show = false" class="btndisable">
                        Continuar
                    </v-btn>
                </div>
            </v-card-title>

            <v-card-text style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                <div style="flex: 1; overflow-y: auto; padding: 16px 0;">
                    <v-row class="py-3" no-gutters >
                        <div
                            v-for="(item, index) in tablesToShow" 
                            :key="index" 
                            :id="`product${item.ID_Customer}`"
                            class="px-3 py-3"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center rounded-full"  
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: esMesaOcupada(item.ID_Customer) ? '#CFD8DC' : getTableColor(item.ID_Customer).main,
                                    color: esMesaOcupada(item.ID_Customer) ? '#757575' : getTableColor(item.ID_Customer).contrast,
                                    cursor: esMesaOcupada(item.ID_Customer) ? 'not-allowed' : 'pointer',
                                }"
                               @click="esMesaOcupada(item.ID_Customer) ? null : activateCurrentItem(index, item)"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{`${item["FirstName"]} ${item["LastName"]}`}}
                                </div>
                            </div>
                        </div>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { pickColorPairById } from '../ProductColorPicker';

export default {
    name: "SearchTable",
    props: [
        "value",
        "activaCommands"
    ],
    data() {
        return {
            tablesToShow: [],
            search: {}
        }
    },
    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
    },
    async mounted() {
        this.search.business = JSON.parse(localStorage.getItem("user")).businessid
        this.search.branch = JSON.parse(localStorage.getItem("user")).branch
        this.search.type = 0
        this.search.Is_a_Table = 1
        this.getCustomers();
    },
    methods: {
        getCustomers() {
            this.$API.customers.getCustomers(this.search)
                .then(response => {
                    console.log('response', response);
                    this.tablesToShow = response;
                })
        },
        getTableColor(id) {
            const colors = pickColorPairById(id);
            return colors
        },
        activateCurrentItem(index, item) {
            console.log('index, item', index, item);
            this.$emit('customerSelected', item);
            this.show = false;
        },
        esMesaOcupada(mesaId) {
            return this.activaCommands?.some(comanda => comanda.ID_Customer === mesaId);
        },
    }
}
</script>

<style scoped>
.btndisable {
    background-color: #41464c !important;
    color: white;
}
.rounded-full {
    border-radius: 50%;
    width: 125px;
    height: 125px;
}
</style>